// extracted by mini-css-extract-plugin
module.exports = {"YHApplyChoose":"index-module_YHApplyChoose_1xxqB","title":"index-module_title_2xfjq"};